// extracted by mini-css-extract-plugin
export default {"previewFileWrapper":"PreviewFIle_previewFileWrapper__RSlvB","footer":"PreviewFIle_footer__AREvy","pdfViewer":"PreviewFIle_pdfViewer__6gxz8","drawer":"PreviewFIle_drawer__W+ZSK"};